// extracted by mini-css-extract-plugin
module.exports = {"tablet":"(max-width: 1024px)","monthsList":"monthsList-1UVdP","monthsList_withPrice":"monthsList_withPrice-3OlLc","month":"month-TH2IG"};